import React from 'react';
import './styles.scss';

const WhyBookWithUs: React.FC = () => {
  return (
    <section className="why-book">
      <h2 className="why-book__title">Why Book With Us</h2>
      <div className="why-book__grid">
        <div className="why-book__item">
          <div className="why-book__icon">🌟</div>
          <h3 className="why-book__item-title">Best Price Guarantee</h3>
          <p className="why-book__description">
            Find a lower price? We'll match it and give you an additional discount.
          </p>
        </div>
        <div className="why-book__item">
          <div className="why-book__icon">🔒</div>
          <h3 className="why-book__item-title">Secure Booking</h3>
          <p className="why-book__description">
            Your payment information is always protected with us.
          </p>
        </div>
        <div className="why-book__item">
          <div className="why-book__icon">📱</div>
          <h3 className="why-book__item-title">Mobile Friendly</h3>
          <p className="why-book__description">
            Book your activities on any device, anywhere, anytime.
          </p>
        </div>
        <div className="why-book__item">
          <div className="why-book__icon">💬</div>
          <h3 className="why-book__item-title">24/7 Support</h3>
          <p className="why-book__description">
            Our customer service team is always here to help you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyBookWithUs;
